import { render, staticRenderFns } from "./WasteDocket.vue?vue&type=template&id=0f60e47e&scoped=true&"
import script from "./WasteDocket.vue?vue&type=script&lang=js&"
export * from "./WasteDocket.vue?vue&type=script&lang=js&"
import style0 from "./WasteDocket.vue?vue&type=style&index=0&id=0f60e47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f60e47e",
  null
  
)

export default component.exports